// extracted by mini-css-extract-plugin
module.exports = {"container":"Amount-module__container___-e_cl","disabled":"Amount-module__disabled___3id1v","button":"Amount-module__button___1MP-n","input":"Amount-module__input___3AfaP"};